import { Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFtlStop extends Layout {
    labelPickupAndDelivery: Label;
    tableStops: Table;
}
